// extracted by mini-css-extract-plugin
module.exports = {"read":"TextRead_read__1igo_"};